import * as React from 'react'

import { Box, Card, fonts } from '@factorialco/deprecated-design-system'
import { ResponsivePie } from '@nivo/pie'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import getPercentageValue from 'modules/engagement/lib/getPercentageValue'
import 'modules/enps/pages/AnalyticsPage/index.styles.css'
import { useAnalytics } from 'modules/enps/pages/AnalyticsPage/useAnalytics'

interface PieChartData {
  data: ChartData[]
}

const PieChart = observer(({ data }: PieChartData) => {
  const SYMBOL_SIZE = 15
  const SYMBOL_SPACING = 4
  const LETTER_SPACE = 7
  const CHART_ARC_SIZE = 68
  const MARGIN = {
    top: 20,
    right: 0,
    bottom: 20,
    left: -2 * CHART_ARC_SIZE,
  }

  const chartTheme = {
    fontSize: Number(fonts.sizes[200].split('px')[0]),
  }
  const longestLabel = Math.max(...data.map((el) => String(el.label).length))
  const legendItemSize = longestLabel * LETTER_SPACE + SYMBOL_SIZE + SYMBOL_SPACING

  return (
    <Box className={'AnalyticsPage_distribution'}>
      <Card>
        <Card.Title>{i18n.t('enps.analytics.distribution')}</Card.Title>
        <Card.Content>
          <Box className={'AnalyticsPage_distributionBox'} height="s200">
            <ResponsivePie
              innerRadius={0.5}
              data={data}
              padAngle={2}
              cornerRadius={3}
              theme={chartTheme}
              enableArcLabels={false}
              enableArcLinkLabels={false}
              activeOuterRadiusOffset={4}
              colors={{ datum: 'data.color' }}
              margin={MARGIN}
              legends={[
                {
                  anchor: 'center',
                  direction: 'column',
                  padding: 0,
                  justify: false,
                  translateX: CHART_ARC_SIZE + legendItemSize,
                  translateY: 0,
                  itemsSpacing: 13,
                  itemWidth: legendItemSize,
                  itemHeight: 19,
                  itemDirection: 'left-to-right',
                  symbolSize: SYMBOL_SIZE,
                  symbolShape: 'circle',
                  symbolSpacing: SYMBOL_SPACING,
                  effects: [],
                },
              ]}
            />
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )
})

interface ChartData {
  id: string
  label: string
  value: number
  color: string
}

const Distribution = () => {
  const { answeredResultsCount, promoters, detractors } = useAnalytics()
  const passives = answeredResultsCount - (promoters + detractors)

  const detractorsPercentage = getPercentageValue(detractors, answeredResultsCount)
  const passivesPercentage = getPercentageValue(passives, answeredResultsCount)
  const promotersPercentage = getPercentageValue(promoters, answeredResultsCount)

  const data: ChartData[] = [
    {
      id: 'promoters',
      label: `${i18n.t('enps.analytics.users.promoters')} ${promotersPercentage}%`,
      value: promotersPercentage,
      color: '#68CC45',
    },
    {
      id: 'passives',
      label: `${i18n.t('enps.analytics.users.passives')} ${passivesPercentage}%`,
      value: passivesPercentage,
      color: '#F7C879',
    },
    {
      id: 'detractors',
      label: `${i18n.t('enps.analytics.users.detractors')} ${detractorsPercentage}%`,
      value: detractorsPercentage,
      color: '#E51943',
    },
  ]

  return <PieChart data={data} />
}

export default observer(Distribution)
